import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export const ROW_MIN_HEIGHT = 36;
export const NOTE_ITEM_MIN_HEIGHT = 25;

export default makeStyles((theme: MuiTheme) => ({
  note: {
    minHeight: NOTE_ITEM_MIN_HEIGHT,
    fontSize: 12,
    color: theme.palette.text.secondary,
    paddingBottom: 8,
    lineHeight: "normal"
  },
  tableRow: {
    borderTop: "1px solid #eeeeee",
    minHeight: ROW_MIN_HEIGHT
  },
  tableCell: {
    color: theme.palette.text.secondary,
    height: 36,
    padding: "4px 16px",
    fontSize: 12,
    border: "none",
    textAlign: "center",
    wordBreak: "break-word",
    "&:first-child": {
      textAlign: "left"
    },
    [theme.breakpoints.down(Breakpoints.SS_320)]: {
      padding: "4px 10px"
    }
  },
  removeRiskIcon: {
    marginLeft: 10
  },
  tableComment: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    paddingTop: 0,
    paddingBottom: 0
  },
  alert: {
    "& $tableCell": {
      color: theme.palette.warning.dark,
      fontSize: 12
    }
  },
  removeRiskButton: {
    color: theme.palette.warning.dark,
    padding: 2,
    cursor: "pointer",
    marginLeft: 6
  },
  removeIcon: {
    fontSize: 22
  }
}));
